import { NeuIcon } from "@neutron/react";

export type IconType =
  "chevron_left" | "chevron_right" 
| "warning"
| "edit_square"
| "edit"
| "supervisor_account"
| "search" | "refresh" | "outgoing_mail"
| "add" | "sort" | "close" | "file_download" | "close" | "remove" | "keyboard_arrow_right" | "filter_alt"
| "expand_less" | "expand_more" | "home" |  "settings" | "zoom_in" | "arrow_drop_down" | "info"
| "check" | "star" | "dashboard" | "check_circle" | "folder" | "business_center" | "assignment" | "group"
| "description" | "help" | "check_box" | "check_box_outline_blank" | "indeterminate_check_box" | "keyboard_arrow_down" 
| "keyboard_arrow_up" | "stat_minus_1" | "lock" | "expand" | "compress" | "play_arrow" | "arrow_forward" | "arrow_back" | "campaign" | "cancel"
| "keyboard_double_arrow_right" | "keyboard_double_arrow_left"

/**
 * Thin wrapper around `<NeuIcon>` but with limits on what values can be entered
 * @NeutronUpdate `slot` will go away completely
 */
export function Icon(props: { className?: string, onClick?: () => void, slot?: string, value: IconType}) {
    return (
        <NeuIcon className={props.className} onClick={props.onClick} slot={props.slot ? props.slot : ""}>
            {props.value}
        </NeuIcon>
    )
}